import React from "react";
import TitlePage from "../../utility/titlePage";
import MainFooter from "../comman/mainFooter";
import MainNavbar from "../comman/mainNavbar";
import { Outlet } from "react-router-dom";
const MainLayout = () => {
  return (
    <>
      <TitlePage title="سامانه پیامکی پیام کوتاه و سرویس خدمات دهی VOP سرویس" />
      <div className="landing-layer">
        <div className="fixed-top"></div>
        <div className="container">
          <MainNavbar />
        </div>
      </div>
      <main style={{ margin: "0 0 200px 0" }}>
        <Outlet />
      </main>
      <MainFooter />
    </>
  );
};

export default MainLayout;
